import Vue from "vue";
import Router from "vue-router";

import store from "./store/";
import { storage } from "@/plugins";

import Login from "@/views/login";
import Acesso from "@/views/login/acesso";
import auth from "@/views/login/auth";
import AcessoExpirado from "@/views/login/acesso-expirado.vue";
import AcessoInativo from "@/views/login/acesso-inativo.vue";
import PrimeiroAcesso from "@/views/login/primeiro-acesso";
import RecuperarSenha from "@/views/login/recuperar-senha";
import RedefinirSenha from "@/views/login/redefinir-senha";

import Carteirinha from "@/views/carteirinha";
import DemonstrativoIr from "@/views/demonstrativo-ir";
import ExtratoDespesas from "@/views/extrato-despesa";
import ExtratoPormenorizado from "@/views/extrato-pormenorizado";
import Fatura from "@/views/fatura";
import HistoricoUtilizacao from "@/views/historico-utilizacao";
import ParcelarFatura from "@/views/fatura/parcelar-fatura/index";
import Pinss from "@/views/pinss";
import Protocolo from "@/views/protocolo";
import Guia from "@/views/guia";
import ValoresPlano from "@/views/valores-plano";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/portal",
      component: () => import("./views/Portal.vue"),
      meta: {
        authRequired: true
      },
      children: [
        {
          path: "",
          name: "home",
          meta: { title: "Portal do Beneficiário" },
          component: () => import("./views/Home.vue")
        },
        {
          path: "carteirinha",
          name: "carteirinha",
          meta: { title: "Carteirinha" },
          component: Carteirinha
        },
        {
          path: "demonstrativo-ir",
          name: "demonstrativoIr",
          meta: { title: "Demonstrativo do IR" },
          component: DemonstrativoIr
        },
        {
          path: "extrato-de-despesas",
          name: "extratoDespesa",
          meta: { title: "Extrato de despesas" },
          component: ExtratoDespesas
        },
        {
          path: "extrato-pormenorizado",
          name: "extratoPormenorizado",
          meta: { title: "Extrato Pormenorizado" },
          component: ExtratoPormenorizado
        },
        {
          path: "faturas",
          name: "faturas",
          meta: { title: "Faturas" },
          component: Fatura
        },
        {
          path: "parcelar-fatura",
          name: "parcelar-fatura",
          meta: { title: "Parcelar Fatura" },
          component: ParcelarFatura
        },
        {
          path: "historico-utilizacao",
          name: "historicoUtilizacao",
          meta: { title: "Histórico Utilização" },
          component: HistoricoUtilizacao
        },
        {
          path: "pinss",
          name: "pinSS",
          meta: { title: "PIN-SS" },
          component: Pinss
        },
        {
          path: "valores-plano",
          name: "valoresPlano",
          meta: { title: "Valores do Plano" },
          component: ValoresPlano
        },
        {
          path: "protocolos",
          name: "protocolos",
          meta: { title: "Meus Protocolos" },
          component: Protocolo
        },
        {
          path: "guias",
          name: "guias",
          meta: { title: "Guias" },
          component: Guia
        },
        {
          path: "perfil",
          name: "profile",
          meta: { title: "Perfil" },
          component: () => import("./views/Profile.vue")
        },
        {
          path: "atualizar-cadastro",
          name: "updateRegistration",
          meta: { title: "Atualizar cadastro" },
          component: () => import("./views/UpdateRegistration.vue"),
          props: route => ({ createDraft: route.query.createDraft === "true" })
        },
        {
          path: "relatorios",
          name: "relatorios",
          meta: { title: "Relatórios" },
          component: () => import("./views/Reports.vue")
        },
        {
          path: "relatorio-dados-titular",
          name: "relatorio dados titular",
          meta: { title: "Relatório Dados Titular" },
          component: () => import("./views/ReportDadosTitular.vue")
        },
        {
          path: "exclusao-do-plano",
          name: "planDelete",
          meta: { title: "Exclusão do plano" },
          component: () => import("./views/PlanDelete.vue")
        },
        {
          path: "documentos",
          name: "document",
          meta: { title: "Documentos" },
          component: () => import("./views/Document.vue")
        },
        {
          path: "movimentacoes",
          name: "movement",
          meta: { title: "Movimentações" },
          component: () => import("./views/Movement.vue")
        },
        {
          path: "movimentacoes/alteracao/:id",
          name: "movementUpdate",
          meta: { title: "Movimento de Alteração" },
          component: () => import("./views/MovementUpdate.vue")
        },
        {
          path: "movimentacoes/carteirinha/:id",
          name: "movementCard",
          meta: { title: "Movimento de Segunda via de Cartão" },
          component: () => import("./views/MovementCard.vue")
        },
        {
          path: "movimentacoes/exclusao/:id",
          name: "movementDelete",
          meta: { title: "Movimento de Exclusão" },
          component: () => import("./views/MovementDelete.vue")
        },
        {
          path: "carta-portabilidade",
          name: "portabilityLetter",
          meta: { title: "Carta de Portabilidades" },
          component: () =>
            import("./views/carta-portabilidade/PortabilityLetter.vue")
        }
      ]
    },
    {
      path: "/acessar",
      component: Login,
      children: [
        {
          path: "",
          name: "acessar",
          meta: { title: "Portal do Beneficiário" },
          component: Acesso,
          props: route => ({
            ...route.params,
            product: "portal-beneficiario"
          })
        },
        {
          path: "/acessar/acesso-expirado",
          name: "acesso-expirado",
          meta: { title: "Acesso Expirado" },
          component: AcessoExpirado,
          props: true
        },
        {
          path: "/acessar/acesso-inativo",
          name: "acesso-inativo",
          meta: { title: "Acesso Inativo" },
          component: AcessoInativo,
          props: true
        },
        {
          path: "/acessar/primeiro-acesso",
          name: "primeiro-acesso",
          meta: { title: "Primeiro Acesso" },
          component: PrimeiroAcesso
        },
        {
          path: "/acessar/recuperar-senha",
          name: "recuperar-senha",
          meta: { title: "Recuperar senha" },
          component: RecuperarSenha
        }
      ]
    },
    {
      path: "/token",
      component: Login,
      children: [
        {
          path: "/token/:token",
          name: "token",
          meta: { title: "Portal do Beneficiário" },
          component: Acesso
        }
      ]
    },
    {
      path: "/redefinir_senha",
      component: Login,
      children: [
        {
          path: "/redefinir_senha",
          name: "redefinir-senha",
          meta: { title: "Redefinir senha" },
          component: RedefinirSenha
        }
      ]
    },
    {
      path: "*",
      redirect: "/acessar"
    }
  ]
});

router.beforeEach((to, from, next) => {
  const redirect = to.query.redirect;
  const beneficiarioStore = store.state.beneficiario;

  if (beneficiarioStore.trocarBeneficiario) {
    store.commit("beneficiario/setTrocarBeneficiario", false);
  }

  document.title = to.meta.title;
  if (to.matched.some(record => record.meta.authRequired)) {
    if (
      redirect ||
      !storage.getItem("oauth") ||
      !beneficiarioStore.dadosBeneficiario?.id ||
      !beneficiarioStore.familiaPessoa.length
    ) {
      auth.logout({ redirect }, store, router);
    } else {
      next();
    }
  } else {
    if (storage.getItem("oauth")) {
      if (to.name === "token") {
        next();
      } else {
        auth.logout({ redirect }, store, router);
      }
    } else {
      next();
    }
  }
});

export default router;
